import clsx from 'clsx';
import * as React from 'react';

import style from './loadingProgressBar.module.scss';

interface LoadingProgressBarProps {
  completed: number;
  theme: 'primary' | 'secondary';
}

export const LoadingProgressBar: React.FunctionComponent<LoadingProgressBarProps> = ({
  completed,
  theme
}) => {
  return (
    <>
      <div className={clsx(style.progressBarContainer)}>
        <div className={clsx(style.fillerStyles)} style={{ width: `${completed}%` }}></div>
      </div>
    </>
  );
};

export default LoadingProgressBar;
